import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const ProtectedVendorRoute = ({ children }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated || !user) {
        navigate('/vendor/login', { replace: true });
      } else if (user.role !== 'vendor' && user.role !== 'admin') {
        navigate('/vendor/login', { replace: true, state: { needsVendorAccount: true } });
      }
    }
  }, [user, loading, isAuthenticated, navigate]);

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF7F2]">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-[#FF5E4C] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Don't render children if not authenticated or not vendor/admin
  // This prevents any content from showing before redirect
  if (!isAuthenticated || !user || (user.role !== 'vendor' && user.role !== 'admin')) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF7F2]">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-[#FF5E4C] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Redirecting...</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedVendorRoute;

